module.exports = __webpack_public_path__ + "static/media/JustAct Icons Download-02.75b8913f.svg";